export function urlBase64ToUint8Array(base64String: string): Uint8Array {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

type BrowserType =
  | "Chrome"
  | "Firefox"
  | "Safari"
  | "Opera"
  | "Edge"
  | "Unknown";

export function getBrowserName(): BrowserType {
  const userAgent = navigator.userAgent;
  let browserName: BrowserType;

  if (userAgent.match(/chrome|chromium|crios/i)) {
    browserName = "Chrome";
  } else if (userAgent.match(/firefox|fxios/i)) {
    browserName = "Firefox";
  } else if (userAgent.match(/safari/i)) {
    browserName = "Safari";
  } else if (userAgent.match(/opr\//i)) {
    browserName = "Opera";
  } else if (userAgent.match(/edg/i)) {
    browserName = "Edge";
  } else {
    browserName = "Unknown";
  }

  return browserName;
}

type DisplayMode =
  | "PWA_STANDALONE"
  | "PWA_FULLSCREEN"
  | "PWA_IOS"
  | "BROWSER_TAB";

export function checkDisplayMode(): DisplayMode {
  if (window.matchMedia("(display-mode: standalone)").matches) {
    return "PWA_STANDALONE";
  }
  if (window.matchMedia("(display-mode: fullscreen)").matches) {
    return "PWA_FULLSCREEN";
  }
  if ("standalone" in window.navigator) {
    // Type check for standalone
    return (window.navigator as any).standalone ? "PWA_IOS" : "BROWSER_TAB";
  }
  return "BROWSER_TAB";
}

export function extractUrlFromText(text: string): string {
  const urlRegex = /(https?:\/\/[^\s]+)/;
  const match = text.match(urlRegex);
  return match ? match[0] : "";
}

export function openNotificationSettings(): void {
  if (!("permissions" in navigator)) return;

  const BROWSER_SETTINGS: {
    [key: string]: string;
  } = {
    Chrome: "chrome://settings/content/notifications",
    Firefox: "about:preferences#privacy",
    Safari: "safari://settings/websites",
  };

  navigator.permissions
    .query({ name: "notifications" as PermissionName })
    .then((result) => {
      if (result.state !== "denied") return;

      const browserName = getBrowserName();
      const settingsUrl = BROWSER_SETTINGS[browserName] || "";

      const message = settingsUrl
        ? `알림이 차단되어 있습니다. ${browserName} 설정에서 알림을 허용해주세요.\n설정 페이지: ${settingsUrl}`
        : "알림이 차단되어 있습니다. 브라우저 설정에서 알림을 허용해주세요.";

      alert(message);
      if (settingsUrl) window.open(settingsUrl, "_blank");
    });
}
